import type { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";
import type { ICheckboxFilterOption } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/types";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import { getLeadScoreFilterOptionLabel } from "../../utils/leadScoreFilterLabels";

import type { LeadScoreFilterOption } from "./const";
import { normalizeLeadScoreFilterValue } from "./leadScoreFilterValue";

export default class LeadScoreFilterModel extends FilterPanelBaseFilter<
    readonly LeadScoreFilterOption[],
    readonly ICheckboxFilterOption<LeadScoreFilterOption>[],
    readonly LeadScoreFilterOption[]
> {
    readonly hasScoringRules: boolean;
    readonly enabledLeadScoreTiers: ReadonlySet<LeadPriorityScore>;

    constructor(
        hasScoringRules: boolean,
        leadScoreGroups: readonly LeadScoreFilterOption[],
        enabledLeadScoreTiers: ReadonlySet<LeadPriorityScore>,
    ) {
        const options = leadScoreGroups.map((value) => ({
            label: getLeadScoreFilterOptionLabel(value),
            value,
        }));

        super({ options });
        this.hasScoringRules = hasScoringRules;
        this.enabledLeadScoreTiers = enabledLeadScoreTiers;
    }

    fromApiValue(value?: readonly LeadScoreFilterOption[]): readonly LeadScoreFilterOption[] {
        return normalizeLeadScoreFilterValue(value);
    }

    calculateValueDelta(
        previousValue?: readonly LeadScoreFilterOption[],
        newValue?: readonly LeadScoreFilterOption[],
    ): FilterValueDelta<LeadScoreFilterOption> {
        return calculateArrayDelta(
            normalizeLeadScoreFilterValue(previousValue),
            normalizeLeadScoreFilterValue(newValue),
        );
    }
}
